module.exports = __webpack_public_path__ + "static/media/15UN-Habitat16.2f55e7e9.jpg";